import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './styles.css';
import './zawajiyyah-redesign.css';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES, getLanguageCookie } from '../utils/language';
import logo from '../media/logo.webp';

const copy = {
  en: {
    brandNote: 'Marriage with intention',
    approach: 'Our approach',
    process: 'How it works',
    memberLogin: 'Member login',
    login: 'Log in',
    join: 'Join Zawajiyyah',
    eyebrow: 'Private · Purposeful · Faith-centred',
    titleMain: 'Marriage,',
    titleEmphasis: 'approached with intention.',
    heroCopy: 'Zawajiyyah is a refined Muslim matchmaking experience for people seeking a serious, respectful path to marriage. Less noise. More clarity. Better introductions.',
    begin: 'Begin your journey',
    principlesLabel: 'Zawajiyyah principles',
    serious: 'Serious intentions',
    respectful: 'Respectful introductions',
    dignified: 'A dignified experience',
    visualLabel: 'Zawajiyyah introduction preview',
    cardKicker: 'A thoughtful introduction',
    cardTitle: 'Beyond a profile.',
    cardCopy: 'Discover compatibility through the things that shape a marriage, not through endless browsing.',
    faith: 'Faith',
    values: 'Values',
    future: 'Future',
    note: 'Where purpose meets possibility.',
    simple: 'Simple by design',
    clearer: 'A clearer path forward.',
    processCopy: 'The experience is designed to keep the focus where it belongs: intention, compatibility and a respectful progression toward marriage.',
    stepOneTitle: 'Introduce yourself',
    stepOneCopy: 'Create a considered profile that reflects who you are, what matters to you and the future you hope to build.',
    stepTwoTitle: 'Find alignment',
    stepTwoCopy: 'Focus on meaningful compatibility rather than surface-level browsing or conversations without direction.',
    stepThreeTitle: 'Proceed with purpose',
    stepThreeCopy: 'Take the next step with maturity, clear expectations and respect for the seriousness of marriage.',
    better: 'A better first step',
    confidence: 'Quiet confidence. Serious purpose.',
    statementCopy: 'Zawajiyyah replaces the usual noise of online matching with a more composed, intentional experience. It is built for people who are ready to approach marriage with clarity.',
    createProfile: 'Create your profile',
    returnAccount: 'Return to your account',
    rights: 'All rights reserved.',
    privacy: 'Privacy',
    terms: 'Terms',
    contact: 'Contact',
  },
  sw: {
    brandNote: 'Ndoa kwa nia',
    approach: 'Mtazamo wetu',
    process: 'Jinsi inavyofanya kazi',
    memberLogin: 'Kuingia kwa mwanachama',
    login: 'Ingia',
    join: 'Jiunge na Zawajiyyah',
    eyebrow: 'Faragha · Malengo · Imani katikati',
    titleMain: 'Ndoa,',
    titleEmphasis: 'ikifikiwa kwa nia.',
    heroCopy: 'Zawajiyyah ni uzoefu uliosafishwa wa kutafuta mwenzi wa Kiislamu kwa watu wanaotaka njia nzito na yenye heshima kuelekea ndoa. Kelele kidogo. Uwazi zaidi. Utambulisho bora.',
    begin: 'Anza safari yako',
    principlesLabel: 'Misingi ya Zawajiyyah',
    serious: 'Nia ya kweli',
    respectful: 'Utambulisho wenye heshima',
    dignified: 'Uzoefu wenye staha',
    visualLabel: 'Onyesho la utambulisho wa Zawajiyyah',
    cardKicker: 'Utambulisho wa kufikiriwa',
    cardTitle: 'Zaidi ya wasifu.',
    cardCopy: 'Gundua uwiano kupitia mambo yanayounda ndoa, si kwa kuvinjari bila mwisho.',
    faith: 'Imani',
    values: 'Maadili',
    future: 'Mustakabali',
    note: 'Mahali kusudi linapokutana na uwezekano.',
    simple: 'Rahisi kwa makusudi',
    clearer: 'Njia iliyo wazi mbele.',
    processCopy: 'Uzoefu umeundwa kuweka mkazo mahali pake: nia, uwiano na mwendo wa heshima kuelekea ndoa.',
    stepOneTitle: 'Jitambulishe',
    stepOneCopy: 'Tengeneza wasifu uliofikiriwa unaoonyesha wewe ni nani, kinachokujali na mustakabali unaotamani kujenga.',
    stepTwoTitle: 'Pata uwiano',
    stepTwoCopy: 'Lenga uwiano wenye maana badala ya kuvinjari juu juu au mazungumzo yasiyo na mwelekeo.',
    stepThreeTitle: 'Endelea kwa kusudi',
    stepThreeCopy: 'Chukua hatua inayofuata kwa ukomavu, matarajio yaliyo wazi na heshima kwa uzito wa ndoa.',
    better: 'Hatua bora ya kwanza',
    confidence: 'Utulivu wa kujiamini. Kusudi zito.',
    statementCopy: 'Zawajiyyah hubadilisha kelele za kawaida za ulinganishaji mtandaoni kwa uzoefu mtulivu na wenye nia. Imejengwa kwa watu walio tayari kuikaribia ndoa kwa uwazi.',
    createProfile: 'Tengeneza wasifu wako',
    returnAccount: 'Rudi kwenye akaunti yako',
    rights: 'Haki zote zimehifadhiwa.',
    privacy: 'Faragha',
    terms: 'Masharti',
    contact: 'Mawasiliano',
  },
  so: {
    brandNote: 'Guur niyad leh',
    approach: 'Habkeenna',
    process: 'Sida ay u shaqayso',
    memberLogin: 'Gelitaanka xubinta',
    login: 'Gal',
    join: 'Ku biir Zawajiyyah',
    eyebrow: 'Asturnaan · Ujeeddo · Iimaan ku dhisan',
    titleMain: 'Guur,',
    titleEmphasis: 'lagu wajahayo niyad.',
    heroCopy: 'Zawajiyyah waa khibrad Muslim ah oo xarrago leh oo loogu talagalay dadka raadinaya waddo dhab ah oo ixtiraam leh oo guur ku wajahan. Buuq yar. Caddeyn badan. Isbarashooyin wanaagsan.',
    begin: 'Bilow safarkaaga',
    principlesLabel: 'Mabaadi’da Zawajiyyah',
    serious: 'Niyad dhab ah',
    respectful: 'Isbarasho ixtiraam leh',
    dignified: 'Khibrad sharaf leh',
    visualLabel: 'Muuqaalka hordhaca Zawajiyyah',
    cardKicker: 'Isbarasho laga fiirsaday',
    cardTitle: 'Ka badan profile.',
    cardCopy: 'Ku ogow iswaafajinta waxyaabaha guurka qaabeeya, ma aha dhex mushaaxid aan dhammaad lahayn.',
    faith: 'Iimaan',
    values: 'Qiyam',
    future: 'Mustaqbal',
    note: 'Meesha ujeedadu kula kulanto suurtagalnimada.',
    simple: 'Si ula kac ah u fudud',
    clearer: 'Waddo ka cad oo horay loo maro.',
    processCopy: 'Khibradda waxaa loo qaabeeyay in diiradda la saaro halka ay mudan tahay: niyad, iswaafajin iyo horumar ixtiraam leh oo guur ku wajahan.',
    stepOneTitle: 'Is bar',
    stepOneCopy: 'Samee profile laga fiirsaday oo muujinaya qofka aad tahay, waxa muhiimka kuu ah iyo mustaqbalka aad rabto inaad dhisto.',
    stepTwoTitle: 'Hel iswaafajin',
    stepTwoCopy: 'Diiradda saar iswaafajin macno leh halkii aad ka eegi lahayd muuqaal dusha sare ah ama sheeko aan jihayn.',
    stepThreeTitle: 'U soco ujeeddo',
    stepThreeCopy: 'Qaado tallaabada xigta si qaan-gaar ah, rajooyin cad iyo ixtiraam ku aaddan culayska guurka.',
    better: 'Tallaabo koowaad oo ka wanaagsan',
    confidence: 'Kalsooni deggan. Ujeeddo dhab ah.',
    statementCopy: 'Zawajiyyah waxay beddeshaa buuqa caadiga ah ee isbarbardhigga internetka iyadoo keenta khibrad deggan oo niyad leh. Waxaa loo dhisay dadka diyaar u ah inay guurka ku wajahaan caddeyn.',
    createProfile: 'Samee profile-kaaga',
    returnAccount: 'Ku noqo akoontigaaga',
    rights: 'Xuquuqda oo dhan way dhowran tahay.',
    privacy: 'Asturnaanta',
    terms: 'Shuruudaha',
    contact: 'Xiriir',
  },
};

function useActiveLanguage(pathname) {
  const [activeLanguage, setActiveLanguage] = React.useState(DEFAULT_LANGUAGE);

  React.useEffect(() => {
    const [, maybeLang] = pathname.split('/');
    if (SUPPORTED_LANGUAGES.includes(maybeLang)) {
      setActiveLanguage(maybeLang);
      return;
    }

    const cookieLang = getLanguageCookie();
    if (cookieLang && SUPPORTED_LANGUAGES.includes(cookieLang)) {
      setActiveLanguage(cookieLang);
      return;
    }

    setActiveLanguage(DEFAULT_LANGUAGE);
  }, [pathname]);

  return activeLanguage;
}

export default function IndexPage() {
  const location = useLocation();
  const activeLanguage = useActiveLanguage(location.pathname);
  const labels = copy[activeLanguage] || copy[DEFAULT_LANGUAGE];
  const year = new Date().getFullYear();

  return (
    <div className="zawajiyyah-redesign">
      <div className="site-shell">
        <div className="orb one" />
        <div className="orb two" />

        <header>
          <nav className="nav" aria-label="Main navigation">
            <Link className="brand" to="/" aria-label="Zawajiyyah home">
              <img className="brand-logo" src={logo} alt="Zawajiyyah logo" />
              <span className="brand-copy">
                <span className="brand-name">Zawajiyyah</span>
                <span className="brand-note">{labels.brandNote}</span>
              </span>
            </Link>

            <div className="nav-links">
              <a href="#approach">{labels.approach}</a>
              <a href="#process">{labels.process}</a>
              <Link to="/login">{labels.memberLogin}</Link>
            </div>

            <div className="nav-actions">
              <Link className="btn btn-secondary" to="/login">{labels.login}</Link>
              <Link className="btn btn-primary" to="/signup">{labels.join}</Link>
            </div>
          </nav>
        </header>

        <main>
          <section className="hero">
            <div>
              <div className="eyebrow">{labels.eyebrow}</div>
              <h1>{labels.titleMain}<em>{labels.titleEmphasis}</em></h1>
              <p className="hero-copy">{labels.heroCopy}</p>

              <div className="hero-actions">
                <Link className="btn btn-primary" to="/signup">
                  {labels.begin}
                  <span aria-hidden="true">↗</span>
                </Link>
                <Link className="btn btn-secondary" to="/login">{labels.memberLogin}</Link>
              </div>

              <div className="trust-line" aria-label={labels.principlesLabel}>
                <span><i /> {labels.serious}</span>
                <span><i /> {labels.respectful}</span>
                <span><i /> {labels.dignified}</span>
              </div>
            </div>

            <div className="visual" aria-label={labels.visualLabel}>
              <div className="arch">
                <div className="arch-inner" />
                <img className="visual-logo" src={logo} alt="" />

                <div className="introduction-card">
                  <div className="card-kicker">{labels.cardKicker}</div>
                  <div className="card-title">{labels.cardTitle}</div>
                  <p className="card-copy">{labels.cardCopy}</p>

                  <div className="criteria">
                    <div className="criterion"><strong>01</strong><span>{labels.faith}</span></div>
                    <div className="criterion"><strong>02</strong><span>{labels.values}</span></div>
                    <div className="criterion"><strong>03</strong><span>{labels.future}</span></div>
                  </div>
                </div>

                <div className="floating-note">
                  <b>Zawajiyyah</b>
                  <span>{labels.note}</span>
                </div>
              </div>
            </div>
          </section>

          <section className="section" id="process">
            <div className="section-head">
              <div className="eyebrow">{labels.simple}</div>
              <h2>{labels.clearer}</h2>
              <p>{labels.processCopy}</p>
            </div>

            <div className="steps">
              <article className="step">
                <div className="step-number">01</div>
                <h3>{labels.stepOneTitle}</h3>
                <p>{labels.stepOneCopy}</p>
              </article>

              <article className="step">
                <div className="step-number">02</div>
                <h3>{labels.stepTwoTitle}</h3>
                <p>{labels.stepTwoCopy}</p>
              </article>

              <article className="step">
                <div className="step-number">03</div>
                <h3>{labels.stepThreeTitle}</h3>
                <p>{labels.stepThreeCopy}</p>
              </article>
            </div>
          </section>

          <section className="statement" id="approach">
            <div className="statement-content">
              <div className="eyebrow">{labels.better}</div>
              <h2>{labels.confidence}</h2>
              <p>{labels.statementCopy}</p>
              <div className="hero-actions">
                <Link className="btn btn-primary" to="/signup">{labels.createProfile}</Link>
                <Link className="btn btn-secondary" to="/login">{labels.returnAccount}</Link>
              </div>
            </div>
          </section>
        </main>

        <footer>
          <div>© <span>{year}</span> Zawajiyyah. {labels.rights}</div>
          <div className="footer-links">
            <Link to="/privacypolicy">{labels.privacy}</Link>
            <Link to="/terms">{labels.terms}</Link>
            <a href="mailto:admin@zawajiyyah.com">{labels.contact}</a>
          </div>
        </footer>
      </div>
    </div>
  );
}
